import { PopoverTemplate } from "themes/common/components";

function Popover(props) {
    return <PopoverTemplate {...props} />;
}

export default Popover;
